import { jsx } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import { Image } from "@zillow/constellation-10";
import PropTypes from "prop-types";
import "react";
const cardImageRootClassName = css({
  overflow: "hidden",
  borderTopLeftRadius: "inherit",
  borderTopRightRadius: "inherit"
});
const CARD_IMAGE_ROOT_DATA_ATTR = "data-zrs-card-image-root";
const cardImageImgStyles = {
  width: "100%",
  maxWidth: "100%",
  height: "auto"
};
const CardImage = ({
  src,
  alt,
  width,
  height,
  ...rest
}) => /* @__PURE__ */ jsx("div", { className: cardImageRootClassName, ...{
  [CARD_IMAGE_ROOT_DATA_ATTR]: true
}, "data-testid": "zrs-card-image-root", children: /* @__PURE__ */ jsx(Image, { src, alt, width, height, ...rest, css: cardImageImgStyles }) });
CardImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number
};
export {
  CARD_IMAGE_ROOT_DATA_ATTR,
  cardImageRootClassName,
  CardImage as default
};
